import {FC, useState} from 'react';
import './ProposalsPromoters.scss';
import SkeletonTable from '../../../components/SkeletonTable/SkeletonTable';
import AppPagination from '../../../components/AppPagination/AppPagination';
import moment from 'moment';
import {useProposalsPromoters} from '../../../providers/ProposalsCovenantsTable/ProposalsPromotersProvider';
import {usePaginate} from '../../../providers/PaginateProvider';
import PainelMasterPage from '../../../components/PainelMasterPage/PainelMasterPage';
import PageBase from '../../../components/PageBase/PageBase';
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import ButtonEdit from "../../../components/ButtonEdit/ButtonEdit";
import ButtonDelete from "../../../components/ButtonDelete/ButtonDelete";
import {ProposalPromoter} from "../../../models/ProposalCovenant/ProposalsCovenantsTableModel";
import ModalProposalPromotersEdit
    from "../../../components/ProposalsTrack/ModalProposalPromotersEdit/ModalProposalPromotersEdit";

interface ProposalsPromotersProps {
}

const ProposalsPromoters: FC<ProposalsPromotersProps> = () => {
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
    const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
    const [itemEdit, setItemEdit] = useState<ProposalPromoter | null>(null);

    const {
        params,
        setParams,
        proposalsPromoters,
        isLoading,
        handleList,
        handleSave,
        handleInative
    } = useProposalsPromoters();
    const {pagesPaginate, handlePaginate} = usePaginate();


    const handleInativeAlert = (item: ProposalPromoter) => {
        Swal.fire({
            title: "Atenção!",
            html: `Deseja realmente inativar a promotora ${item.name}`,
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            showConfirmButton: true,
            showCancelButton: true,
        }).then((value) => {
            if (value.isConfirmed) {
                deleteItem(item)
            }

        })
    }

    const deleteItem = async (item: ProposalPromoter) => {
        const res = await handleInative(item?.id ?? null);
        if (!res) {
            handleList();
            toast.success(`${item.name} inativada com sucesso!`)
            return;
        }

        toast.error(res)

    }


    const renderList = () => {
        if (proposalsPromoters?.length > 0) {
            return (
                <>
                    {proposalsPromoters?.map((x: any) => (
                        <tr key={x.id}>
                            <td className="text-sm text-center">{x.id}</td>
                            <td className="text-sm text-wrap" style={{width: '20%'}}>{x.name}</td>
                            <td className="text-center text-sm">
                <span className={`badge ${!!x.deleted_at ? 'badge-danger' : 'badge-success'}`}>
                  {!!x.deleted_at ? 'Inativa' : 'Ativa'}
                </span>
                            </td>
                            <td className="text-center text-sm">{moment(x.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                            <td className='text-center text-sm'>
                <span className='d-flex gap-2'>
                                <ButtonEdit
                                    tooltipText="Editar"
                                    onClick={() => {
                                        setItemEdit(x);
                                        setShowModalInsert(true);
                                    }}
                                />
                                <ButtonDelete
                                    onClick={() => handleInativeAlert(x)}
                                    tooltipText="Inativar"/>
                                 </span>
                            </td>
                        </tr>
                    ))}
                </>
            );
        } else {
            return (<tr className='text-sm text-center'>
                <td colSpan={5}>Não há registros</td>
            </tr>);
        }
    }

    const renderContent = () => {
        return (
            <div className="table-responsive p-0">
                {isLoading ? (
                    <SkeletonTable columns={5}/>
                ) : (
                    <table className="table table-flush">
                        <thead className="thead-light">
                        <tr>
                            <th className="text-center" scope="col">#ID</th>
                            <th scope="col">NOME</th>
                            <th scope="col" className="text-center">STATUS</th>
                            <th scope="col" className="text-center">DATA DE CADASTRO</th>
                            <th className="text-center" scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderList()}
                        </tbody>
                    </table>
                )}

                {(pagesPaginate) && (
                    <div>
                        <nav aria-label="...">
                            <AppPagination
                                pages={pagesPaginate}
                                handlePaginate={handlePaginate}
                                params={params}
                                setParams={setParams}
                            />
                        </nav>
                    </div>
                )}
            </div>
        )
    }

    return (
        <PainelMasterPage
            title='Promotoras'
            icon='fas fa-comments-dollar'
        >
            <div className="ProposalsPromoters" data-testid="ProposalsPromoters">
                <PageBase
                    content={renderContent()}
                    title={'Promotoras'}
                    subtitle={'Listagem de promotoras'}
                    hasFilter={false}
                    textButtonAdd='+ Nova Promotora'
                    handleAdd={() => setShowModalInsert(true)}
                    handleFilter={() => setShowModalFilter(true)}
                />
            </div>

            <ModalProposalPromotersEdit
                show={showModalInsert}
                onClose={() => {
                    setShowModalInsert(false);
                    setItemEdit(null);
                }}
                item={itemEdit}
            />

        </PainelMasterPage>
    );
}

export default ProposalsPromoters;
